import { useState } from "react";
import { Tile } from "../../reactOL/layers";
import { OSMGreyscaleDark } from "../../reactOL/source";

const DarkOsmTileLayer = () => {
  const [source] = useState(() => OSMGreyscaleDark());

  return <Tile source={source} />;
};

export default DarkOsmTileLayer;
